<script setup lang="ts">
  import { useCssVar } from '@vueuse/core'
  import { KsSkeleton } from '@aschehoug/kloss'

  const skeletonLoadingColor = useCssVar('--color-yellow-20')
</script>

<template>
  <div class="glosses" data-testid="skeleton">
    <KsSkeleton
      v-for="(_, i) in Array(4)"
      :key="i"
      width="125px"
      height="5rem"
      border-radius="0"
      :background="skeletonLoadingColor"
    />
  </div>
</template>

